import { useAppSelector } from "../../../hooks/useRedux";

const CHP_PRACTICE_ID = "9b839347-34b6-4266-a70f-ad2512a31a0c";
const ALLOWED_CHP_PROVIDER_IDS = ["09b942c7-5454-4d97-b478-ccf8c4ab5620"];

export default function useCanViewEPrescribeFlow() {
    const { practice } = useAppSelector((state) => state.userPractice);

    return (
        import.meta.env.VITE_NODE_ENV !== "production" ||
        (practice?.practice_id === CHP_PRACTICE_ID &&
            practice.provider_id !== null &&
            ALLOWED_CHP_PROVIDER_IDS.includes(practice.provider_id))
    );
}
